import { defineComponent as r, openBlock as o, createBlock as l, unref as p, mergeProps as c, withCtx as i, createElementVNode as e } from "vue";
import { RevIcon as m } from "@ds/components/Icon";
const d = /* @__PURE__ */ r({
  name: "IconArrowUpRightInCircle",
  __name: "IconArrowUpRightInCircle",
  props: {
    size: {},
    alternativeText: {}
  },
  setup(a) {
    const n = a;
    return (h, t) => (o(), l(p(m), c(n, { "view-box": "0 0 24 24" }), {
      default: i(() => [...t[0] || (t[0] = [
        e("path", { d: "M12 20.25a8.25 8.25 0 1 0 0-16.5 8.25 8.25 0 0 0 0 16.5m0 1.5c-5.385 0-9.75-4.365-9.75-9.75S6.615 2.25 12 2.25s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75" }, null, -1),
        e("path", { d: "M15.53 9.53a.75.75 0 0 0-1.06-1.06l-6 6a.75.75 0 0 0 1.06 1.06l6-6" }, null, -1),
        e("path", { d: "M14.614 13.707a.75.75 0 0 0 1.5 0V9.136a1.25 1.25 0 0 0-1.25-1.25h-4.571a.75.75 0 1 0 0 1.5h4.321v4.321" }, null, -1),
        e("path", { d: "M16.114 13.707a.75.75 0 0 1-1.5 0v-3.26L9.53 15.53a.75.75 0 1 1-1.06-1.06l5.084-5.084h-3.261a.75.75 0 1 1 0-1.5h4.571a1.25 1.25 0 0 1 1.25 1.25v4.571" }, null, -1)
      ])]),
      _: 1
    }, 16));
  }
});
export {
  d as default
};
